import * as icons from '@creditornot/alchemy-react/icons';
import { TextButton } from '@creditornot/cb-button';
import { MenuActionItem } from '@creditornot/cb-menu';
import { Popover } from '@creditornot/cb-popover';
import { PopoverContent } from 'common/components/cookbook/PopoverContent';
import { Stack } from 'common/components/cookbook/Stack';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useSetSearch } from 'common/hooks/useSetSearch';

import {
  selectionRecommendationsRouteApi,
  SelectionRecommendationsSearchRouteSchemaType,
} from '..';

export const TimePeriod = () => {
  const f = useFormatMessage();
  const { timePeriod = 'LAST_WEEK' } = selectionRecommendationsRouteApi.useSearch();
  const setSearch = useSetSearch<SelectionRecommendationsSearchRouteSchemaType>();

  const menuItems = {
    LAST_WEEK: {
      label: f('selection_recommendations.performance_overview_time_period_last_week'),
      value: 'LAST_WEEK',
    },
    LAST_MONTH: {
      label: f('selection_recommendations.performance_overview_time_period_last_month'),
      value: 'LAST_MONTH',
    },
  } as const;

  return (
    <Popover
      openOnClick={true}
      content={
        <PopoverContent>
          <Stack gap="narrowSmall">
            {Object.entries(menuItems).map(([key, { label, value }]) => (
              <MenuActionItem
                key={key}
                variant="black"
                selected={timePeriod === value}
                onClick={() => {
                  setSearch({ timePeriod: value });
                }}
              >
                {label}
              </MenuActionItem>
            ))}
          </Stack>
        </PopoverContent>
      }
      placement="bottom-end"
      zIndex={1}
      renderArrow={false}
    >
      {({ refProps }) => {
        return (
          <TextButton {...refProps} icon={icons.chevronDown} iconPosition="end">
            {menuItems[timePeriod].label}
          </TextButton>
        );
      }}
    </Popover>
  );
};
